import React from "react";
import { useTranslation } from "react-i18next";
import { getNetwork, setNetwork } from "../config";

export function NetworkSelector() {
  const { t } = useTranslation();
  const currentNetwork = getNetwork();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setNetwork(e.target.value as "MAINNET" | "TESTNET");
  };

  return (
    <select
      value={currentNetwork}
      onChange={handleChange}
      className="network-selector"
      style={{
        padding: "0.5rem",
        borderRadius: "4px",
        background: "var(--color-bg)",
        color: "var(--color-text)",
        border: "1px solid var(--color-border)",
        cursor: "pointer"
      }}
    >
      <option value="MAINNET">🔴 Live (Mainnet)</option>
      <option value="TESTNET">🟢 Testnet</option>
    </select>
  );
}
